<template>
    <div id="payment-form">
        <v-flex class="xs12">
            <v-text-field
                id="name_on_card"
                label="Name On Card"
                v-model="name_on_card"
                placeholder="Please Enter"
                :error-messages="errors($v.name_on_card)"
                @blur="$v.name_on_card.$touch()"
                @focus="emitReset"
            ></v-text-field>
        </v-flex>
        <v-flex class="xs12 pt-1 px-0 card-input" :class="{'focused': inputActive}">
            <label :class="{[cardErrorMessage.length > 0 ? 'error--text' : 'primary--text']: inputActive || cardErrorMessage.length > 0}">Card</label>
            <card class='stripe-card'
                :class='{ complete }'
                :stripe='stripe_key'
                :options='stripeOptions'
                @change='change'
                @focus='inputActive = !inputActive'
                @blur='inputActive = !inputActive'
            />
            <div 
                class="card-input-line" 
                :class="{[cardErrorMessage.length > 0 ? 'error--text' : 'primary--text']: inputActive || cardErrorMessage.length > 0}"
                :style="cardErrorMessage.length > 0 ? { borderColor: $vuetify.theme.error } : ''"
            ></div>
            <div class="caption error--text" id="card-errors" role="alert" v-text="cardErrorMessage"></div>
        </v-flex>
        <p class="note mt-3">*Enter Credit Card to Be Used for Payments.</p>
    </div>
</template>



<script>
    import { Card, createToken } from 'vue-stripe-elements-plus'
    import { MIX_STRIPE_KEY } from "@/common/config";
    import { validationMixin } from 'vuelidate'
    import { required, email } from 'vuelidate/lib/validators'
    import { valMessages, getValMessage } from '@/common/error-messages'

    const validations = {
        name_on_card: { required }
    }

    export default {
        name: 'CardForm',
        components: { Card },
        props: ['formBus'],
        mixins: [validationMixin],
        validations,
        data () {
          return {
            name_on_card: '',
            inputActive: false,
            stripe_key: MIX_STRIPE_KEY,
            complete: false,
            cardErrorMessage:'',
            stripeOptions: {
                // see https://stripe.com/docs/stripe.js#element-options for details
                  style: {
                    base: {
                      color: '#32325d',
                    //   lineHeight: '18px',
                      fontFamily: 'Roboto, sans-serif',
                      fontSmoothing: 'antialiased',
                      fontSize: '16px',
                      '::placeholder': {
                        color: 'rgba(0,0,0,0.42)'
                      }
                    },
                    invalid: {
                      color: '#fa755a',
                      iconColor: '#fa755a'
                    }
                  },
                  hidePostalCode: true
            }
          }
        },
        created() {
            this.$watch('$v.name_on_card.$error', () => {
                this.emitState();
            })
        },
        mounted() {
            this.formBus.$on('gaveMeToken', this.pay)
        },
        methods: {
            pay() {
              // createToken returns a Promise which resolves in a result object with
              // either a token or an error key.
              // See https://stripe.com/docs/api#tokens for the token object.
              // See https://stripe.com/docs/api#errors for the error object.
              // More general https://stripe.com/docs/stripe.js#stripe-create-token.
              this.$v.name_on_card.$touch()
                var options = {
                name: this.name_on_card,
                }
                createToken(options).then(data => {
                    // console.log(data.token);
                        if(!this.$v.name_on_card.$invalid) {
                            this.submit(data);
                        } else {
                            this.submit({error: 'No name on Card'});
                        }
                    }
                ).catch(error => {
                    console.log(error);
                })
              },
            submit(data){
                this.$emit('token', data)
            },
            change(event) {
                this.complete = event.complete && !this.$v.name_on_card.$invalid
                this.cardErrorMessage = event.error ? event.error.message : ''
                this.emitState()
            },
            emitState() {
                let data = { 
                    cardErrorMessage: this.cardErrorMessage, 
                    nameErrorMessage: this.errors(this.$v.name_on_card) ? this.errors(this.$v.name_on_card) : '', 
                    complete: this.complete && !this.$v.name_on_card.$invalid }
                this.$emit('state', data)
                this.emitReset()
            },
            stripeCardFocus () {

            },
            emitReset() {
                this.$emit('resetServer')
            },
            errors: getValMessage(valMessages)(validations)
         },
         watch: {
            'name_on_card': function(val) {
                this.emitState()
            }
         }
       }
</script>

<style scoped>
.container.grid-list-md .layout:not(:only-child) {
    margin: auto 0px;
}
.note{
    padding: 10px 0px;
    font-size: 12px;
    color: gray;
    font-style: italic;
}
.v-card .grid-list-md {
    max-width: 450px;
    padding-top: 50px;
    padding-bottom: 50px;
    padding-left: 0;
    padding-right: 0;
}
.spacer{
    display: block;
    width: 100%;
}
.theme--light .toolbar {
    background-color: #3AB0CE;
    color: rgb(255, 255, 255);
}
.v-card__text.zip-form {
    padding: 35px;
    width: 100%;
    max-width: 540px;
    margin: 0px auto;
}
.img-wrap {
    padding: 25px 0px!important;
    text-align: right;
}
.v-card{
    box-shadow: none;
}
.terms{
    margin-top: 0px;
}
.terms .accent--text{
    color: #3ab0cf !important;
}
.sub-button{
    display: -webkit-box;
    display: -ms-flexbox;
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    color:white!important;
    flex: 1;
    margin: 6px 0;
    background-color: #3ab0cf!important;
    width: 100%;
    text-align: center;
    padding:15px!important;
    font-weight: 300;
    font-size: 16px;
    margin-top: 20px;
    height: auto;
}
.sub-button .btn__content{
    padding:9px;
}
.application .theme--light.btn:not(.btn--icon):not(.btn--flat),
.theme--light .btn:not(.btn--icon):not(.btn--flat) {
    background-color: #3ab0ce;
    color: white;
    padding: 0;
}
.form-control:focus {
    color: #495057;
    border: none;
    background-color: #fff;
    border-color: #ffffff;
    outline: 0;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    box-shadow: none;
    border-bottom: 1px solid gray;
}
.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 0.9rem;
    line-height: 1.6;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: none;
    border-radius: 0.25rem;
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    border-bottom: 1px solid #b5b5b5;
    border-radius: 0;
}
.container.fill-height .layout.one-time-payment-wrapper  {
    height: auto!important;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
}
label.onetimeLabel{
 color: rgba(0, 0, 0, 0.54);
    font-family: Roboto, sans-serif;
    font-size: 16px;
    font-weight: 400;
    -webkit-transform: scale(.75)!important;
    transform: scale(.75);
    margin-left: -14px;
        display: inline-block;
    margin-bottom: 0;
}
#name_on_card{
    font-size: 16px;
    padding-left: 0;
    padding-top: 0;
}
@media only screen and (max-width: 600px) {
    .one-time-payment-wrapper .img-wrap {
        text-align:center;
    }
    .one-time-payment-wrapper .img-wrap img{
        padding: 0 3px;
    }
}



.theme--light .toolbar {
    background-color: #3AB0CE;
    color: rgb(255, 255, 255);
}
.card__text.zip-form {
    padding: 35px;
    width: 100%;
    max-width: 540px;
    margin: 0px auto;
}
.application .theme--light.btn:not(.btn--icon):not(.btn--flat),
.theme--light .btn:not(.btn--icon):not(.btn--flat) {
    background-color: #3ab0ce;
    color: white;
    padding: 0;
}
.StripeElement {
    background-color: white;
    height: 40px;
    padding: 10px 12px;
    border-radius: 0;
    border-bottom: 1px solid #b5b5b5;
    -webkit-box-shadow: 0 1px 3px 0 #e6ebf1;
    box-shadow: none;
    -webkit-transition: box-shadow 150ms ease;
    -webkit-transition: -webkit-box-shadow 150ms ease;
    transition: -webkit-box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease, -webkit-box-shadow 150ms ease;
    width: 100%;
}
#payment-form .card {
    display: block;
    border-radius: 2px;
    min-width: 0;
    position: relative;
    text-decoration: none;
    box-shadow: none;
    border: none;
}
.stripe-card.complete {
  border-color: green;
}
#payment-form .card-images {
    padding: 0 2px;
}

.card-input .card-input-line {
    margin-top: 5px; 
    border-color: rgba(0,0,0,0.42); 
    border-style: solid; 
    border-width: thin 0 0 0; 
    position: relative;
}

.card-input label {
    font-size: 13px; color: rgba(0,0,0,0.54)
}

.card-input .card-input-line:after {
    border-color: currentColor;
    border-style: solid;
    border-width: thin 0 thin 0;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
}

.card-input .card-input-line:after {
    bottom: -0px;
    content: '';
    left: 0;
    position: absolute;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
}

.card-input.focused .card-input-line:after {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
}
</style>
